import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import {
  injectIntl,
  SmartDialog,
} from 'components';

const styles = () => ({
  actions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  description: {
    marginBottom: 25,
    textAlign: 'center',
  },
});

const ConfirmSignupIgnoreDialog = ({
  classes,
  description,
  formatMessage,
  onClose,
  onConfirm,
  open,
  title,
}) => {
  let filteredDesc = '';
  if (description.indexOf('auth.signup.ignoreBuyer') > -1) {
    filteredDesc = 'You have already been invited as a buyer. So please either change your role to \'Chef/Grocer\' or click confirm to ignore this invite.';
  } else if (description.indexOf('auth.signup.ignoreBuyer') > -1) {
    filteredDesc = 'You have already been invited as a seller. So please either change your role to \'Farmer\' or click confirm to ignore this invite.';
  }
  return (
    <SmartDialog
      onClose={onClose}
      open={open}
      title={title}
    >
      <div className="confirm-signup-ignore-dialog">
        <Typography
          className={classes.description}
          gutterBottom
          variant="body1"
        >
          {filteredDesc !== '' && formatMessage(filteredDesc)}
        </Typography>
        <div className={classes.actions}>
          <Button
            color="primary"
            onClick={onConfirm}
            variant="contained"
          >
            {formatMessage('Confirm')}
          </Button>
          <Button
            onClick={onClose}
            variant="text"
          >
            {formatMessage('Cancel')}
          </Button>
        </div>
      </div>
    </SmartDialog>
  );
};

ConfirmSignupIgnoreDialog.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  description: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,

  formatMessage: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default compose(
  setDisplayName('ConfirmSignupIgnoreDialog'),
  withStyles(styles),
  injectIntl,
)(ConfirmSignupIgnoreDialog);
